import React from 'react';

const TestRequestPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto bg-white rounded-xl p-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">صفحه تست درخواست نصب</h1>
          <p className="text-gray-600">اگر این صفحه را می‌بینید، مسیر درست کار می‌کند.</p>
          <p className="text-gray-500 mt-2">مسیر: /installation/request</p>
          <button
            onClick={() => alert('دکمه کار می‌کند!')}
            className="mt-4 bg-blue-600 text-white px-4 py-2 rounded-lg"
          >
            تست دکمه
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestRequestPage;